import { applyFiltersFailed, applyFiltersSucceeded } from './actionCreators';
import { ActionTypes } from './actionTypes';
import { all, put, takeLatest } from 'redux-saga/effects';

import Alert from '@cobliteam/ui/components/Alert';

function* requestApplyVehicleGroupsFilterSaga() {
  try {
    yield put(applyFiltersSucceeded());
  } catch {
    yield put(applyFiltersFailed());
    Alert.error('Houve um erro, tente novamente mais tarde.');
  }
}

export function* MonitoringVehiclesTabSagasListener() {
  yield all([takeLatest(ActionTypes.APPLY_VEHICLE_GROUPS_FILTER_REQUEST, requestApplyVehicleGroupsFilterSaga)]);
}
